import React from 'react'
import { ProductWithActiveColour } from '../../types'

interface Props {
  product: ProductWithActiveColour
}

export const ProductSaleTag: React.FC<Props> = ({ product }) => {
  if (product.activeColour.sale_price) {
    return <span className="productblock-sale">SALE</span>
  }

  return null
}
